import styled from 'styled-components';
import image from './../../_static/others/Wallet-Hero.jpg';
import logo from './../../_static/logo.png';

export const RegisterBackgroud = styled.div`
    width: 100%;
    height: 100vh;
    margin: 0;
    top: 0;
    left: 0;
    position: absolute;
    background: url(${image});
    background-size: cover;
`;

export const BoxLayout = styled.div`
    height: 100vh;
    background-color: #ffffff !important;
    
    .loading {
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 9999;
    }
`;

export const BoxRegister = styled.div`
    padding: 30px 10px 10px 10px;
    
    .logo {
        position: relative;
        background: url(${logo}) center center no-repeat;        
        background-size: contain;
        height: 140px;
        min-width: 50px;
        width: 100%;        
    }
`;

export const LoginRuler = styled.div`
    padding-left: 20px;
`;

export const HaveAcount = styled.div`
    font-size: 1.1em;
`;
